module.exports = __webpack_public_path__ + "static/media/jeremiah.d745738f.png";


//////////////////
// WEBPACK FOOTER
// ./src/prelogin/public/img/testimonial/jeremiah.png
// module id = 1231
// module chunks = 0